(function () {
  'use strict';

  if (window.__peakLoveHouseMenuInit) return;
  window.__peakLoveHouseMenuInit = true;

  var DESKTOP_QUERY = '(min-width: 992px)';
  var CLOSE_DELAY = 120;

  var desktopMq = window.matchMedia(DESKTOP_QUERY);
  var header = null;
  var trigger = null;
  var item = null;
  var panel = null;
  var content = null;
  var mobilePanel = null;
  var closeTimer = null;
  var isOpen = false;

  function isDesktop() {
    return desktopMq.matches;
  }

  function buildPanel() {
    var el = document.createElement('div');
    el.className = 'house-menu';
    el.id = 'house-menu';
    el.setAttribute('role', 'menu');
    el.setAttribute('aria-label', 'House');
    var cfg = window.peakLoveHouseMenu || {};
    el.innerHTML =
      '<div class="house-menu__bg" aria-hidden="true">' +
        '<img src="' + (cfg.bg || '') + '" alt="">' +
      '</div>' +
      '<div class="house-menu__content lr-pad">' +
        '<a href="' + (cfg.about || '/pages/house') + '" class="house-menu__link" role="menuitem">' +
          '<span class="house-menu__title">About</span>' +
          '<span class="house-menu__hint">House</span>' +
        '</a>' +
        '<a href="' + (cfg.husen || '/pages/husen-baba') + '" class="house-menu__link" role="menuitem">' +
          '<span class="house-menu__title">Husen Baba</span>' +
          '<span class="house-menu__hint">The translator</span>' +
        '</a>' +
      '</div>';
    return el;
  }

  function lockScroll() {
    if (window.lenis) window.lenis.stop();
    document.documentElement.classList.add('scrollBlock');
  }

  function unlockScroll() {
    document.documentElement.classList.remove('scrollBlock');
    if (window.lenis && !document.body.classList.contains('page-home')) {
      window.lenis.start();
    }
  }

  /* While the veil is up the pointer is parked in the header, which would drag
     the frame to its dark end. Hand it to its own drift, kept on the light half
     so nothing behind the vellum turns heavy. */
  function homeFrameDrift(on) {
    if (!document.body.classList.contains('page-home')) return;
    var host = document.querySelector('.products-wrapper [data-dither]');
    var dither = host && host._ditherCanvas;
    if (!dither || typeof dither.setIdle !== 'function') return;
    if (on) dither.setIdle(true, 0.7, 1);
    else dither.setIdle(false, 0, 1);
  }

  function openMenu() {
    if (!isDesktop() || !panel) return;
    clearTimeout(closeTimer);
    if (isOpen) return;
    isOpen = true;
    item.classList.add('is-open');
    panel.classList.add('is-open');
    homeFrameDrift(true);
    trigger.setAttribute('aria-expanded', 'true');
    lockScroll();
  }

  function closeMenu() {
    if (!isOpen) return;
    isOpen = false;
    item.classList.remove('is-open');
    panel.classList.remove('is-open');
    homeFrameDrift(false);
    trigger.setAttribute('aria-expanded', 'false');
    unlockScroll();
  }

  function scheduleClose() {
    clearTimeout(closeTimer);
    closeTimer = setTimeout(closeMenu, CLOSE_DELAY);
  }

  function onKeydown(e) {
    if (!isOpen || e.key !== 'Escape') return;
    closeMenu();
    trigger.focus();
  }

  function buildMobilePanel() {
    var existing = item.querySelector('.house-menu-mobile');
    if (existing) return existing;

    var cfg = window.peakLoveHouseMenu || {};
    var ul = document.createElement('ul');
    ul.className = 'house-menu-mobile';
    ul.id = 'house-menu-mobile';
    ul.innerHTML =
      '<li><a href="' + (cfg.about || '/pages/house') + '" class="house-menu-mobile__link">About</a></li>' +
      '<li><a href="' + (cfg.husen || '/pages/husen-baba') + '" class="house-menu-mobile__link">Husen Baba</a></li>';
    item.appendChild(ul);
    return ul;
  }

  function setMobileOpen(open) {
    if (!item || !trigger) return;
    item.classList.toggle('is-open', open);
    trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
  }

  function onTriggerClick(e) {
    if (isDesktop()) return;
    e.preventDefault();
    e.stopPropagation();
    setMobileOpen(!item.classList.contains('is-open'));
  }

  function syncAriaControls() {
    if (!trigger) return;
    trigger.setAttribute('aria-controls', isDesktop() ? 'house-menu' : 'house-menu-mobile');
  }

  function onBreakpointChange() {
    if (!isDesktop()) {
      closeMenu();
    } else {
      setMobileOpen(false);
    }
    syncAriaControls();
  }

  function init() {
    header = document.querySelector('.site-header');
    trigger = document.querySelector('.site-header a.main-nav[title="House"]');
    if (!header || !trigger) return;

    item = trigger.closest('li');
    if (!item) return;

    item.classList.add('has-house-menu');
    trigger.setAttribute('aria-haspopup', 'true');
    trigger.setAttribute('aria-expanded', 'false');
    syncAriaControls();

    panel = buildPanel();
    header.appendChild(panel);
    content = panel.querySelector('.house-menu__content');
    mobilePanel = buildMobilePanel();

    trigger.addEventListener('click', onTriggerClick);
    item.addEventListener('mouseenter', openMenu);
    item.addEventListener('mouseleave', scheduleClose);
    content.addEventListener('mouseenter', openMenu);
    content.addEventListener('mouseleave', scheduleClose);
    document.addEventListener('keydown', onKeydown);
    desktopMq.addEventListener('change', onBreakpointChange);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
